<template>
  <!-- 全屏页右侧功能按钮区 -->
  <div class="vertical_function">
    <!-- 黑金专属 -->
    <div v-show="stadium_current.is_black_vip==1" class="vertical_function_item">
      <wx-open-launch-weapp id="launch-btn" username="gh_9f895bb61a7d" path="pages/fb_index/fb_index.html">
        <script type="text/wxtag-template">
          <style>
            .btn {width: 60px;background: none;border: none;outline: none;}
            .btniiiii{width: 45px;}
          </style>
          <button class="btn">
            <img class="btniiiii" src="http://img.unionfit.cn/blackvip.png" />
          </button>
        </script>
      </wx-open-launch-weapp>
    </div>
    <!-- 预约 -->
    <div v-show="stadium_current.is_black_vip!=1" class="vertical_function_item">
      <img src="../../assets/images/base/order.png" />
      <div>预约</div>
      <button @click="toCreateOrder()" v-preventReClick></button>
    </div>
    <!-- 视频 -->
    <div v-if="stadium_current.env_video==''||stadium_current.env_video==null||stadium_current.env_video==undefined"></div>
    <div v-else class="vertical_function_item">
      <img src="../../assets/images/base/video.png" />
      <div>视频</div>
      <button @click="toOpenVideo()" v-preventReClick></button>
    </div>
    <!-- 介绍 -->
    <div class="vertical_function_item">
      <img src="../../assets/images/base/description.png" />
      <div>介绍</div>
      <button @click="toOpenDesc()" v-preventReClick></button>
    </div>
  </div>
</template>

<script>
  export default {
    props:{
      stadium_current:Object
      // radio:String,
      // loaded:Boolean,
      // fl_stadium_list:Array,
    },
    data() {
      return {
  
      }
    },
    created() {},
    mounted() {
  
    },
    methods:{
      toCreateOrder(){
        this.$emit('toCreateOrder')
      },
      toOpenVideo(){
        this.$emit('toOpenVideo')
      },
      toOpenDesc(){
        this.$emit('toOpenDesc')
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .vertical_function{
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 3;
    width: 120*@vm_base;
    margin-bottom: 104*@vm_base;
    .vertical_function_item{
      width: 100%;
      position: relative;
      margin-bottom: 60*@vm_base;
      img{
        width: 60*@vm_base;
        margin: 0 auto;
      }
      .vertical_function_item_blackvip{
        width: 70%;
      }
      div{
        width: 100%;
        text-align: center;
        margin-top: 2*@vm_base;
        font-size: 28*@vm_base;
        font-weight: 400;
        color: #FFFFFF;
      }
      button{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 120*@vm_base;background: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/subgroup/stadiumDetailFunctionArea.vue